import ImageAtom from "@components/atoms/Image";
import { ImageLabel } from "@components/atoms/ImageLabel/ImageLabel";
import { VariantCountBadge } from "@components/atoms/VariantCountBadge/VariantCountBadge";
import type { CarImage } from "@interfaces/gallery";
import styles from "./ImageCard.module.scss";

interface ImageCardProps {
  image: CarImage;
  onClick: (variantId: string) => void;
  showVariantCount?: boolean;
  variantCount?: number;
  className?: string;
  priority?:boolean;
}

export const ImageCard = ({
  image,
  onClick,
  showVariantCount = false,
  variantCount = 0,
  className = "",
  priority=false
}: ImageCardProps) => {
  return (
    <div
      className={`${styles["image-card"]} ${className}`}
      onClick={() => onClick(image.variant_Id)}
    >
      <ImageAtom
        src={image.image_src}
        alt={image.alt}
        fill
        className={styles["image-card__image"]}
        priority={priority}
      />
      {/* {image.label && <ImageLabel label={image.label} />} */}
      {showVariantCount && <VariantCountBadge count={variantCount + ""} />}
    </div>
  );
};
